import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Title, Subtitle } from './Utils/CustomClasses'

const PricesPanelSection = styled.div`
  padding: 5.5vw 13vw 80px 13vw;

  background-color: ${({ color }) => (color ? color : '#fff')};
  § img {
    width: 100%;
  }

  @media only screen and (max-width: 980px) {
    padding: 80px 5vw 80px 5vw;
  }

  @media only screen and (max-width: 600px) {
    padding: 60px 9vw 80px 8vw !important;
  }
`

const PriceChoiceBox = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 9px -2px #b5b5b5;
  border: 1px solid #eee;
  padding: 26px 26px 30px;
  width: 100%;
  max-width: 950px;
  margin: 40px auto 0 auto;
`

const PriceChoiceSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
  font-size: 16px;
  margin: 40px 20px 30px 20px;

  @media (max-width: 799px) {
    font-size: 18px !important;
  }
`

const PriceSubtitle = styled(Subtitle)`
  color: #000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  margin: 0 16px 0 0;

  @media (max-width: 799px) {
    font-size: 50px !important;
  }
`

const FlexRowPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  justify-content: flex-end;
  margin-top: 30px;

  & > div {
    flex-basis: 50%;
  }

  @media (max-width: 799px) {
    flex-direction: column;
    margin-top: 20px;

    & > div {
      width: -webkit-fill-available;
    }
  }
`

const PriceBox = styled.div`
  box-shadow: ${(props) => (props.shadow ? '0 5px 9px -2px #b5b5b5;' : 'none')};
  border: 1px solid #a5a5a5;
  border-radius: 10px;
  overflow: hidden;
  min-height: 300px;
`

const PriceBoxHeader = styled.div`
  background-color: #4350b0;
  padding: 6px;
`

const PriceBoxHeaderBadgeContainer = styled.div`
  position: relative;
`

const PriceBoxHeaderBadge = styled.div`
  background-color: #9b0000;
  border-radius: 50%;
  height: 90px;
  width: 90px;
  padding: 4px 0 0 0;
  position: absolute;
  top: -26px;
  right: -10px;
`

const PriceHeaderSubtitle = styled(Subtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
`

const PriceHeaderBadgeSubtitle = styled(PriceHeaderSubtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-size: 19px;
  font-weight: 400;
  line-height: 126%;
  margin: 16px 0 0;
`

const InfoBox = styled.div`
  flex-basis: 100%;

  @media (max-width: 799px) {
    padding: 0 5vw;
  }
`

const PriceBoxPrice = styled.div`
  border-bottom: 1px solid #a5a5a5;
  align-items: center;
  justify-content: center;
`

const PriceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 30px auto 34px;
  width: 170px;
`

const CurrencySubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-size: 23px;
  font-weight: 400;
  margin: -36px 4px 0 0;
`

const PriceDurationSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  color: ${(props) => (props.color ? props.color : '#6a6a6a')};
  font-weight: 600;
  letter-spacing: 0px;
  margin: 0 0 0 2px;

  @media (max-width: 799px) {
    font-size: 14px !important;
  }
`

const PriceBoxInfo = styled.div`
  padding: 20px;
  align-items: center;
  justify-content: center;
  text-align: center;

  img {
    margin: 0 auto 20px;
    width: 100%;
    max-width: 170px;
  }

  @media (max-width: 499px) {
    padding: 20px 0 !important;
  }
`

const PriceInfoSubtitle = styled(Subtitle)`
  color: #5a5a5a;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  letter-spacing: 0px;
  margin: 0 auto 30px auto;
  width: 100%;
  max-width: 250px;
  min-height: 81px;

  b {
    color: #06944d;
    font-weight: 700;
  }

  @media (max-width: 799px) {
    font-size: 21px !important;
    width: 270px;
  }

  @media (max-width: 499px) {
    font-size: 18px !important;
    width: 100%;
  }

  @media (min-width: 1100px) {
    font-size: 20px !important;
  }
`

const PriceBoxListIcon = styled.div`
  margin: 0 auto 40px;

  img {
    margin-bottom: 20px;
    width: 200px;
  }

  @media screen and (max-width: 799px) {
    margin: 0 7vw 40px;
  }
`

const PriceBoxList = styled.ul`
  margin: 40px auto 40px;

  width: 100%;
  max-width: 400px;

  @media screen and (max-width: 540px) {
    margin: 60px 7vw 40px;
    width: auto;
  }
`

const PblI = styled.li`
  margin: 0 0 24px 20px;
  position: relative;
  font-size: 20px;

  &::before {
    content: url('images/onboarding/tick-green.svg');
    font-size: 20px;
    position: absolute;
    left: -30px;
    width: 24px;
  }
`

const OurPricesPanel = ({
  pageTextIntro,
  pageTextPrices,
  currencySign,
  backgroundColor,
}) => {
  const leftRef = useRef(null)
  const rightRef = useRef(null)

  useEffect(() => {
    if (pageTextPrices.length !== 0) {
      handleResizeColumns()
    }
  }, [pageTextPrices])

  useEffect(() => {
    function handleResize() {
      handleResizeColumns()
    }
    window.addEventListener('resize', handleResize)
  }, [])

  const handleResizeColumns = () => {
    leftRef.current.style.minHeight = `auto`
    rightRef.current.style.minHeight = `auto`

    const leftHeight = leftRef.current.getBoundingClientRect().height
    const rightHeight = rightRef.current.getBoundingClientRect().height

    if (leftHeight >= rightHeight) {
      rightRef.current.style.minHeight = `${leftHeight}px`
    } else if (rightHeight >= leftHeight) {
      leftRef.current.style.minHeight = `${rightHeight}px`
    }
  }

  if (pageTextIntro.length === 0 || pageTextPrices.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageTextPrices[9]}</span>
        </div>
      </div>
    )
  }
  return (
    <PricesPanelSection color={backgroundColor}>
      <Title
        center
        color="#154549"
        margin="0 0 20px 0"
        size="32px"
        sizemd="2.25rem"
        sizesm="30px"
        dangerouslySetInnerHTML={{ __html: pageTextPrices[70] }}
      />
      <Subtitle
        center
        color="#154549"
        weight="400"
        size="21px"
        sizemd="1.25rem"
        sizesm="22px"
        margin="0 0 30px 0"
        dangerouslySetInnerHTML={{ __html: pageTextPrices[71] }}
      />
      <Subtitle
        center
        color="#154549"
        weight="400"
        size="21px"
        sizemd="1.25rem"
        sizesm="22px"
        margin="0 0 50px 0"
        dangerouslySetInnerHTML={{
          __html: `We have 2 different membership plans to choose from, as best suits your needs: Monthly and Annual`,
        }}
      />
      <PriceChoiceBox>
        <FlexRowPrice>
          <PriceBoxHeaderBadgeContainer>
            <PriceBox>
              <PriceBoxHeader>
                {' '}
                <PriceHeaderSubtitle
                  center
                  size="18px"
                  margin="0"
                  dangerouslySetInnerHTML={{
                    __html: `Monthly`,
                  }}
                />
              </PriceBoxHeader>
              <PriceBoxPrice>
                <PriceContainer>
                  <CurrencySubtitle
                    center
                    size="16px"
                    margin="0"
                    dangerouslySetInnerHTML={{
                      __html: `${currencySign}`,
                    }}
                  />
                  <PriceSubtitle
                    center
                    size="50px"
                    margin="0"
                    dangerouslySetInnerHTML={{
                      __html: `4.99`,
                    }}
                  />

                  <PriceDurationSubtitle
                    center
                    size="13px"
                    margin="0"
                    dangerouslySetInnerHTML={{
                      __html: `EVERY MONTH`,
                    }}
                  />
                </PriceContainer>
              </PriceBoxPrice>
              <PriceBoxInfo ref={leftRef}>
                <PriceBoxListIcon>
                  {' '}
                  <img src={'images/onboarding/icon-coffee-solo.svg'} />
                  <PriceInfoSubtitle
                    center
                    size="18px"
                    margin="0"
                    dangerouslySetInnerHTML={{
                      __html: `${pageTextPrices[72]}`,
                    }}
                  />
                </PriceBoxListIcon>
              </PriceBoxInfo>
            </PriceBox>
          </PriceBoxHeaderBadgeContainer>

          <PriceBoxHeaderBadgeContainer>
            <PriceBoxHeaderBadge>
              {' '}
              <PriceHeaderBadgeSubtitle
                center
                size="28px"
                margin="0"
                dangerouslySetInnerHTML={{
                  __html: `Best<br/>value`,
                }}
              />
            </PriceBoxHeaderBadge>
            <PriceBox>
              <PriceBoxHeader>
                {' '}
                <PriceHeaderSubtitle
                  center
                  size="18px"
                  margin="0"
                  dangerouslySetInnerHTML={{
                    __html: `Annual`,
                  }}
                />
              </PriceBoxHeader>
              <PriceBoxPrice>
                <PriceContainer>
                  <CurrencySubtitle
                    center
                    size="16px"
                    margin="0"
                    dangerouslySetInnerHTML={{
                      __html: `${currencySign}`,
                    }}
                  />
                  <PriceSubtitle
                    center
                    size="50px"
                    margin="0"
                    dangerouslySetInnerHTML={{
                      __html: `44.99`,
                    }}
                  />

                  <PriceDurationSubtitle
                    center
                    size="13px"
                    margin="0"
                    dangerouslySetInnerHTML={{
                      __html: `${pageTextPrices[33]}`,
                    }}
                  />
                </PriceContainer>
              </PriceBoxPrice>
              <PriceBoxInfo ref={rightRef}>
                <PriceBoxListIcon>
                  {' '}
                  <img src={'images/onboarding/icon-annual-connections.svg'} />
                  <PriceInfoSubtitle
                    center
                    size="18px"
                    margin="0"
                    dangerouslySetInnerHTML={{
                      __html: `Ideal for the avid traveller, an annual membership offers you more time to build meaningful connections,
                                    plan trips, organise meetups and more with fellow Freebird Club members.<br/><b>Equivalent to 3 months free.</b>`,
                    }}
                  />
                </PriceBoxListIcon>
              </PriceBoxInfo>
            </PriceBox>
          </PriceBoxHeaderBadgeContainer>
        </FlexRowPrice>

        <InfoBox>
          <PriceChoiceSubtitle
            center
            size="28px"
            margin="0 0 10px 1%"
            dangerouslySetInnerHTML={{
              __html: `${pageTextPrices[23]}`,
            }}
          />
        </InfoBox>
      </PriceChoiceBox>
      <Title
        center
        color="#154549"
        size="29px"
        sizemd="29px"
        sizesm="29px"
        margin="60px 0 0"
        dangerouslySetInnerHTML={{
          __html: `What Freebird Club Membership entails:`,
        }}
      ></Title>
      <PriceBoxList>
        <PblI>Get travel tips & advice from members</PblI>
        <PblI>Arrange meet-ups with locals</PblI>
        <PblI>Find travel buddies to go on trips with</PblI>
        <PblI>Book or host friendly homestays</PblI>
        <PblI>Participate in group events</PblI>
        <PblI>Special offers from tourism partners</PblI>
      </PriceBoxList>
    </PricesPanelSection>
  )
}
export default OurPricesPanel
